export const page12 = {
  "name": "page12",
  "title": "Change",
  "elements": [
    {
      "type": "tagbox",
      "name": "change_areas",
      "title": "Which 3 areas do you feel are most in need of change to improve your currnet health and well-being?",
      "isRequired": true,
      "choices": [
        {
          "value": "Item 1",
          "text": "Sleep"
        },
        {
          "value": "Item 2",
          "text": "Nutrition"
        },
        {
          "value": "Item 3",
          "text": "Physical activity"
        },
        {
          "value": "Item 4",
          "text": "Body weight"
        },
        {
          "value": "Item 5",
          "text": "Mental health"
        },
        {
          "value": "Item 6",
          "text": "A sense of purpose and relationships"
        },
        {
          "value": "Item 7",
          "text": "Consuming addictive substances"
        }
      ]
    }
  ]
};